export default "__VITE_ASSET__BdurbqKY__"